import React from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    DateInput,
    DateField,

    SearchInput,

} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import ShipmentShow from './ShipmentShow'
import jwt_decode from 'jwt-decode';
import ErrorBoundary from '../ErrorBoundary';

const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};


export const ShipmentFilter = props => (
    <Filter {...props}>
        <SearchInput source="shipping_case_no" alwaysOn  placeholder='Shipping Case Number'/>
        <DateInput source="bleed_date" locales="en-us"/>
        <DateInput source="shipping_date" locales="en-us"/>
        <TextInput source="ucn" lable="Unit Control Number" />
        <TextInput source="name" lable="Name" />
        <TextInput source="case_no" lable="Pack Case Number" />
        <TextInput source="ssn" lable="SSN" />
    </Filter>
);

export const DisposalList = props => (
<ErrorBoundary>  
    <List 
        {...props}
        filters={<ShipmentFilter />}
        perPage={20}
        sort={{ field: 'bleed_date', order: 'DESC' }}
        bulkActionButtons ={false}
        
        >
        <Datagrid    expand={<ShipmentShow />} >
            <TextField source="shipping_case_no" label="Ship Case#" />
            <TextField source="case_no" label="Pack Case#" />      
            <TextField source="ucn" label="Unit Control#" />
            <TextField source="name" lablel="Name"/>
            <DateField source="bleed_date" label="Bleed Date"  locales="en-us"/>
            <DateField source="shipping_date" label="Shipping Date"  locales="en-us"/>
        </Datagrid>
    </List>
</ErrorBoundary>  
);


export default DisposalList